var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"round",class:{
    main: _vm.type === 1,
    secondary: _vm.type === 2,
    thirdary: _vm.type === 3
  }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }